import { InfoCircleOutlined } from '@ant-design/icons'
import { useSites } from '@api/useSites'
import { GraviButton, NotificationMessage, Texto } from '@gravitate-js/excalibrr'
import { Button, Input } from 'antd'
import React, { useState } from 'react'

export function SiteNotes({ store, canEditStores }) {
  const { TextArea } = Input

  const [isEditing, setIsEditing] = useState(!store?.notes || false)
  const [note, setNote] = useState(store?.notes)
  const [showCancel, setShowCancel] = useState(false)

  const { updateSiteMutation } = useSites()
  const { mutateAsync } = updateSiteMutation()
  const onChange = (e) => {
    setNote(e.target.value)
  }
  const saveNote = () => {
    if (note) {
      // if there is a note then save and hit ep here

      const request = { ...store, notes: note }

      mutateAsync(request)
        .then(() => {
          NotificationMessage('Site Updated', 'Site note has been updated.', false)
        })
        .catch((err) => {
          NotificationMessage('Problem saving site note', `ERROR: ${err}`, true)
        })

      setIsEditing(false)
    }
  }
  const cancel = () => {
    setNote(store.notes)
    setShowCancel(false)
    if (store.notes) setIsEditing(false)
  }
  const removeNote = () => {
    setNote(null)
    setShowCancel(false)
    // set note to empty then hit ep to save it
    const request = { ...store }
    request.notes = null
    mutateAsync(request)
      .then(() => {
        NotificationMessage('Site Updated', 'Site note has been removed.', false)
        setIsEditing(true)
      })
      .catch((err) => {
        NotificationMessage('Problem saving site note', `ERROR: ${err}`, true)
      })
    setIsEditing(true)
  }

  return (
    <div className='full-height-width p-4 pl-3 text-gray-600 store-expand-card'>
      <div>
        <b className='text-size-5'>Site Notes</b>
        <div className='mt-2 flex-1'>
          <InfoCircleOutlined /> Add a note to this site that drivers will see in-cab when heading to this location.
        </div>
      </div>
      <div className='flex-1 pt-5'>
        {isEditing ? (
          <TextArea
            size='large'
            showCount
            maxLength='300'
            onChange={onChange}
            value={note}
            allowClear
            rows={4}
            autoSize={{ minRows: 4 }}
            disabled={!canEditStores || !isEditing}
          />
        ) : (
          <div className='bg-2 p-3' style={{ height: 150 }}>
            <Texto style={{ whiteSpace: 'normal' }} category='h5'>
              {note}
            </Texto>
          </div>
        )}
      </div>
      <div className='flex' style={{ justifyContent: 'space-between', marginTop: 30 }}>
        {canEditStores && (
          <div>
            {isEditing && showCancel && <Button onClick={cancel}>Cancel</Button>}
            {!isEditing && !!note && (
              <Button type='primary' danger onClick={removeNote}>
                Remove
              </Button>
            )}
          </div>
        )}
        {canEditStores && (
          <div>
            {isEditing || !note ? (
              <GraviButton theme2 onClick={saveNote}>
                Save Note
              </GraviButton>
            ) : (
              <GraviButton
                theme2
                onClick={() => {
                  setIsEditing((prev) => !prev)
                  setShowCancel(true)
                }}
              >
                Edit
              </GraviButton>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
